import * as yup from "yup";

export const createBannerSchema = (v, t, isEditMode) => {
  return yup.object().shape({
    title: v.string().required(),

    titleEn: yup.string().required(t("thisFieldIsRequired")).matches(/^[^؀-ۿ]+$/, t("englishOnlyField")),

    subtitle: v.string().required(),

    subtitleEn: yup.string().required(t("thisFieldIsRequired")).matches(/^[^؀-ۿ]+$/, t("englishOnlyField")),

    tripsId: yup
      .array()
      .of(yup.mixed())
      .min(1, t("thisFieldIsRequired"))
      .required(t("thisFieldIsRequired")),

    file: isEditMode
      ? yup.mixed().nullable()
      : yup.mixed().required(t("thisFieldIsRequired")),
  });
};